export enum Roles {
  ADMIN,
  SUPER_USER,
  USER
}
